import {get} from "svelte/store";
import {
    NavigationStateStore,
    StoredApplicationData,
    SuspectedConditions,

} from "./Store";
import {retrieveBaseMedicalQuestions} from "./ApplicationDataService";
import {NavigationState} from "../models/NavigationState";
import {ApplicationData} from "../models/ApplicationData";
import {resetStoredMedicalQuestions} from "./QuestionDataService";

export function resetNavigationForApplication(applicationData: ApplicationData) {
    resetStoredMedicalQuestions();
    const navState = get(NavigationStateStore);
    const isHonestyStatementCompleted = navState.honestyStatementCompleted;
    resetNavigationState(navState);
    resetCompletedState(navState);
    navState.honestyStatementCompleted = isHonestyStatementCompleted;
    navState.honestyStatement = true;
    if (isHonestyStatementCompleted === true || navState.honestyStatementChecked === true) {
        honestyStatementCompleted(applicationData);
    }
    navState.medicalQuestionsRetrievalComplete = false;
    navState.phoneInterviewInstructions = false;
    NavigationStateStore.set(navState);
}

export function  restoreEligibleSetting(){
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.honestyStatementEligible = true;
        navState.readyToBeContactedEligible = true;
        navState.contactMeCompleted = false;
        navState.lockApplicationSelection = false;
        NavigationStateStore.set(navState);
    }
}

export function honestyStatementCompleted(applicationData: ApplicationData) {
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.honestyStatementCompleted = true;
        navState.honestyStatement = false;
        navState.applicationReviewEligible = true;
        navState.hipaaEligible = true;
        navState.identificationUploadEligible = true;
        navState.readyToBeContactedEligible = true;
        navState.applicationReview = true;
        navState.honestyStatementChecked = true;
        navState.hipaaCompleted = applicationData.isHipaaSignatureCompleted;
        navState.medicalQuestionsEligible = applicationData.isHipaaSignatureCompleted;
        navState.identificationUploadCompleted = applicationData.isDriverLicenseUploaded;
        navState.readyToBeContactedEligible = applicationData.isDriverLicenseUploaded;
        navState.contactMeCompleted = false;
        NavigationStateStore.set(navState);
    }
}

export function applicationReviewCompleted() {
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.applicationReviewCompleted = true;
        navState.applicationReviewEligible = false;
        navState.hipaaEligible = true;
        findNextStateForApplicationReview(navState);
        NavigationStateStore.set(navState);
    }
}

export function hipaaCompleted() {
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.hipaaCompleted = true;
        navState.hipaaEligible = false;
        navState.medicalQuestionsEligible = true;
        findNextStateForHipaa(navState);
        NavigationStateStore.set(navState);
        startMedicalQuestionsProcess();
    }
}


export function startMedicalQuestionsProcess() {
    // Retrieve Medical Questions once hipaa is complete
    const appData = get(StoredApplicationData);
    retrieveBaseMedicalQuestions(appData);
}

export function medicalQuestionsCompleted() {
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.medicalQuestionsCompleted = true;
        navState.medicalQuestionsEligible = false;
        navState.identificationUploadEligible = true;
        findNextStateForMedicalQuestions(navState);
        NavigationStateStore.set(navState);
    }
}


export async function identificationCompleted() {
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.identificationUploadCompleted = true;
        navState.identificationUploadEligible = false;
        navState.readyToBeContactedEligible = true;
        findNextStateForIdentificationUpload(navState);
        NavigationStateStore.set(navState);
    }
}

export async function identificationSkipped(applicationData: ApplicationData) {
    const navState = get(NavigationStateStore);
    if (navState) {
        navState.identificationUploadCompleted = applicationData && applicationData.isDriverLicenseUploaded == true ? true : false;
        navState.identificationUploadEligible = true;
        navState.readyToBeContactedEligible = true;
        findNextStateForIdentificationUpload(navState);
        NavigationStateStore.set(navState);
    }
}

export function readyToBeContactedCompleted() {
    const navState = get(NavigationStateStore);
    if (navState) {
        resetNavigationState(navState);
        navState.readyToBeContactedComplete = true;
        navState.disableAll = true;
        navState.phoneInterviewInstructions = true;
        navState.lockApplicationSelection = true;
        NavigationStateStore.set(navState);
    }
}

export function lockApplicationSelection(isLocked: boolean) {

    const navState = get(NavigationStateStore);
    if (navState) {
        navState.lockApplicationSelection = isLocked;
        NavigationStateStore.set(navState);
    }
}

function resetNavigationState(navState: NavigationState) {
    navState.applicationReview = false;
    navState.hipaa = false;
    navState.medicalQuestions = false;
    navState.identification = false;
    navState.readyToBeContacted = false;
    navState.disableAll = false;
    navState.lockApplicationSelection = false;
}

function resetCompletedState(navState: NavigationState) {
    navState.honestyStatementCompleted = false;
    navState.applicationReviewCompleted = false;
    navState.hipaaCompleted = false;
    navState.medicalQuestionsCompleted = false;
    navState.identificationUploadCompleted = false;
    navState.readyToBeContactedComplete = false;
    navState.contactMeCompleted = false;
}


function findNextStateForApplicationReview(navState: NavigationState) {
    resetNavigationState(navState);
    if (!navState.hipaaCompleted) {
        navState.hipaa = true;
        return;
    }
    if (!navState.medicalQuestionsCompleted) {
        startMedicalQuestionsProcess();
        navState.medicalQuestions = true;
        return;
    }
    if (!navState.identificationUploadCompleted) {
        navState.identification = true;
        return;
    } else {
        navState.readyToBeContacted = true;
        return;
    }
}

function findNextStateForHipaa(navState: NavigationState) {
    resetNavigationState(navState);
    if (!navState.medicalQuestionsCompleted) {
        navState.medicalQuestions = true;
        return;
    }
    if (!navState.identificationUploadCompleted) {
        navState.identification = true;
        return;
    } else {
        navState.readyToBeContacted = true;
        return;
    }
}

function findNextStateForMedicalQuestions(navState: NavigationState) {
    resetNavigationState(navState);
    if (!navState.identificationUploadCompleted) {
        navState.identification = true;
        return;
    } else {
        navState.readyToBeContacted = true;
    }
}

function findNextStateForIdentificationUpload(navState: NavigationState) {
    resetNavigationState(navState);
    navState.readyToBeContacted = true;
    return;
}
